module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAIAAACMMcMmAAAAj0lEQVRIx2NgyPKjORpJdujE+yQEePS7ujV6uAeGeomn+FLTDt40v+lObl+0HJHRS13HVH9PRqrYwZ/me9nYGc0COJrr6EYFOzB9gIaCQrwossMw1hu/BUB0z8CJkRI7cvw8CNoBRMqJPuTbMc/BjRg7gkM8B7cd9AgresQ5PdIunfIgPcoSOpWJo3UUEgIAUuQyY8VBI8wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bd.png
// module id = 775
// module chunks = 0